import { render, staticRenderFns } from "./relativedDr.vue?vue&type=template&id=128263b4&scoped=true"
import script from "./relativedDr.vue?vue&type=script&lang=js"
export * from "./relativedDr.vue?vue&type=script&lang=js"
import style0 from "./relativedDr.vue?vue&type=style&index=0&id=128263b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128263b4",
  null
  
)

export default component.exports